// @flow

import { type PendingIncomingPayment } from './types';

export function getOxxoBarcode(incomingPayment: PendingIncomingPayment): string {
  const oxxoBarcode = incomingPayment['oxxo_barcode'];
  if (!oxxoBarcode)
    throw new Error('Oxxo: Invalid state - There is no oxxo_barcode property for this payment');

  return oxxoBarcode;
}
